import React from 'react'
import Button from './UI/Button'
import T from './UI/T'
import Title from './UI/Title'
import { FiCamera, FiUpload } from 'react-icons/fi'

export default function Home({ start, logo }) {
  return (
    <div className="flex flex-col justify-center items-center w-full h-screen lg:max-w-5xl mx-auto p-4 lg:p-6 pb-16 lg:pb-32 ">
      <img className="w-1/2 max-w-md" src={logo} />
      <div className="flex text-center">
        <div className="text-3xl lg:text-4xl font-medium mt-16 md:mt-32"><T>welcome_digital.title</T></div>
        <div className="text-xl lg:text-2xl"><T>welcome_digital.subtitle</T></div>
      </div>
      <div className="mt-20 lg:mt-48 flex flex-col justify-center items-center">
        <Button onClick={() => start('photo')} className="my-2" Icon={FiCamera}><T>welcome_digital.photo</T></Button>
        <Button onClick={() => start('upload')} className="my-2" Icon={FiUpload}><T>welcome_digital.upload</T></Button>
      </div>
    </div>
  )
}
